import React, { useState } from 'react';
import { SplitPayment } from '../../pages';
import * as yup from 'yup';
import { observer } from 'mobx-react';
import { TransactionsController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { transactionStore } from '../../stores';
import { amountFormatter } from '../../utils/utils';

const SplitViewMoreContainer = ({ closeModal }) => {
    const [loading, setLoading] = useState(false);
    const [editState, setEditState] = useState(false);
	const { actionSplitPayment, updateSplitAmount } = TransactionsController;

    const actionSplit = async (id, actionStatus) => {
		setLoading(true);
		const { status, errorMessage } = await actionSplitPayment({ id, status: actionStatus });
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	}
	const onSubmit = async (payload) => {
		setLoading(true);
		payload.id = transactionStore.selectedSplitTrans?._id;
		const { status, errorMessage } = await updateSplitAmount(payload);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	}
    const gotoEditState = () => {
        setEditState(!editState)
	}
    const validationSchema = () => {
		return yup.object({
			payDeductions: yup.array(
				yup.object({
					amount: yup.number()
						.min(1, 'Minimum amount is 1')
						.required('Amount is required'),
					description: yup.string().required('Description is required'),
				})
			),
			payAdditions: yup.array(
				yup.object({
					amount: yup.number()
						.min(1, 'Minimum amount is 1')
						.required('Amount is required'),
					description: yup.string().required('Description is required'),
				})
			),
		});
	};
    const totalExtra = extra => {
		const totalAmount = extra.reduce(
			(previousValue, currentValue) => previousValue + currentValue.amount,
			0
		);
		return amountFormatter().format(totalAmount);
	};

    return (
        <SplitPayment
            closeModal={closeModal}
            editState={editState}
            transaction={transactionStore.selectedSplitTrans}
            gotoEditState={gotoEditState}
            totalExtra={totalExtra}
            validationSchema={validationSchema}
            actionSplit={actionSplit}
			onSubmit={onSubmit}
            loading={loading}
        />
    )
}

export default observer(SplitViewMoreContainer);